<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card tm-pc-info-card">
    <v-row class="com-pc-card-header">
      <div class="com-pc-card-title">{{ text.obsInfo }}</div>
      <div class="tm-pc-info-card-info-area">
        <v-btn
          v-if="information.length > 0"
          outlined
          x-small
          class="tm-pc-info-color"
          :style="setInfoColor()"
          @click="openInfo()"
        >
          <span>{{ setInfoText() }}</span>
        </v-btn>
        <v-tooltip left v-if="!pcPanelMode">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              dark
              small
              @click="changePanelMode(true)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>fullscreen</v-icon>
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.panelModeOn }}</span>
        </v-tooltip>
        <v-tooltip left v-if="pcPanelMode">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              dark
              small
              @click="changePanelMode(false)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>fullscreen_exit</v-icon>
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.panelModeOff }}</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon dark small @click="openObs()" v-bind="attrs" v-on="on">
              <v-icon>open_in_new</v-icon>
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.detailView }}</span>
        </v-tooltip>
      </div>
    </v-row>
    <v-row class="com-pc-card-contents" no-gutters>
      <v-expansion-panels accordion light class="tm-pc-obs-panel">
        <v-expansion-panel>
          <v-expansion-panel-header class="tm-pc-obs-panel-header" expand-icon="arrow_drop_down">
            <v-row class="tm-pc-info-card-info">
              <v-col class="tm-pc-info-card-name-area">
                <v-row no-gutters>
                  <div>
                    <span class="tm-pc-info-card-name-kana">{{
                      tmRainList.tmRainDetailInfo.obsKana
                    }}</span>
                    <span class="tm-pc-info-card-name">{{
                      tmRainList.tmRainDetailInfo.obsNm
                    }}</span>
                  </div>
                  <div class="pl-2">
                    <div class="tm-pc-info-card-name-kana">
                      {{ tmRainList.tmRainDetailInfo.rsysKana
                      }}{{ text.rsysKana }}
                    </div>
                    <div class="tm-pc-info-card-name">
                      {{ tmRainList.tmRainDetailInfo.rsysNm }}{{ text.rsys }}
                    </div>
                  </div>
                  <div class="pl-2">
                    <div class="tm-pc-info-card-name-kana">
                      {{ tmRainList.tmRainDetailInfo.rvrKana }}
                    </div>
                    <div class="tm-pc-info-card-name">
                      {{ tmRainList.tmRainDetailInfo.rvrNm }}
                    </div>
                  </div>
                </v-row>
                <v-row no-gutters v-show="!pcPanelMode">
                  <div class="tm-pc-curt-time">
                    {{ text.obsTime }} {{ tmRainList.curt.obsTime }}
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list dense>
              <!-- 観測所情報 -->
              <v-list-item
                v-for="(item, index) in tmRainList.obsInfo"
                :key="`obs-${index}`"
              >
                <v-list-item-content>{{ item.title }}</v-list-item-content>
                <v-list-item-content
                  v-if="showQwtrDbBtn(item.qwtrObsCd, item.dbLink)"
                >
                  <div class="tm-pc-link" @click="openQwtrDb(item.qwtrObsCd)">
                    {{ item.obsValue }}
                  </div>
                  <!-- <div class="tm-pc-link" @click="openRnRank(item.qwtrObsCd)">
                    {{ item.rankValue }}
                  </div> -->
                </v-list-item-content>
                <v-list-item-content v-else>
                  <div style="line-break: strict">
                    <span class="list-value">{{ item.value }}</span>
                    <span class="list-unit">{{ item.unit }}</span>
                    <span class="list-value">{{ item.code }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <!-- 基準値(注意値/警戒値) -->
              <v-list-item
                v-for="(item, index) in tmRainList.standardValue"
                :key="`sd-${index}`"
              >
                <v-list-item-content>{{ item.title }}</v-list-item-content>
                <v-list-item-content>
                  <div>
                    <span class="list-value">{{ item.value }}</span>
                    <span class="list-unit">{{ item.unit }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <!-- コード値 -->
              <v-list-item
                v-for="(item, index) in codeInfo"
                :key="`cd-${index}`"
              >
                <v-list-item-content>{{ item.title }}</v-list-item-content>
                <v-list-item-content>
                  <div>
                    <span class="list-value">{{ item.value }}</span>
                    <span class="list-unit">{{ item.unit }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]雨量 観測所情報カード
 * TmRainInfo.vue
 * @author ILUKE
 */
import Util from "./../../lib/util.js";
import mixin from "./../../lib/mixin.js";

export default {
  name: "tm-rain-info",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        info: "お知らせ",
        obsInfo: "観測所情報",
        obsTime: "最新観測値",
        obsType: "雨量",
        rsys: "水系",
        rsysKana: "すいけい",
      },
    };
  },
  created() {
    this.$store.dispatch("map/getObsInformation", {
      ofcCd: this.$store.state.Telemeter.selectedTmParam.ofcCd,
      itmkndCd: this.$store.state.Telemeter.selectedTmParam.itmkndCd,
      obsCd: this.$store.state.Telemeter.selectedTmParam.obsCd,
    });
  },
  computed: {
    /**
     * 雨量情報 取得
     */
    tmRainList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /**
     * コード値 取得
     */
    codeInfo: {
      get() {
        return this.$store.state.Telemeter.selectedTm.codeInfo;
      },
    },
    /**
     * お知らせ情報全件取得
     */
    information: {
      get() {
        return this.$store.state.map.information;
      },
    },
    /**
     * フレームの拡大・縮小判定用
     */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
    /** ツールチップ共通文言 */
    tooltipStr: {
      get() {
        return this.$store.state.app.config.messageConfig.commonTooltip;
      },
    },
    /** お知らせのタイトルと色 */
    titleSummaryCode: {
      get() {
        return this.$store.state.info.titleSummaryCode;
      },
    },
    /** お知らせ設定情報 */
    infoConfig: {
      get() {
        return this.$store.state.info.informationConfig;
      },
    },
  },
  methods: {
    /** お知らせ情報表示 */
    openInfo() {
      let noCloselFlg = false;
      if (this.$store.state.map.showInformation === false) {
        if (this.information.length === 1) {
          // 1件のみの場合は直接遷移する
          this.linkInfoUrl(this.information[0].infoManageCode);
        } else {
          this.$store.commit("map/showInformation");
        }
      } else if (!this.pcPanelMode) {
        this.$store.commit("map/hideInfoRw");
      }
      if (this.pcPanelMode && !noCloselFlg) {
        // 1件のみ以外の場合に拡大表示を止める
        this.replacePanelMode("0");
        this.$store.commit("app/setPcPanelMode", false);
      }
    },
    /** 詳細画面遷移 */
    openObs() {
      if (!this.$store.state.app.isCurrent) {
        let routeData = this.$router.resolve({
          name: "tm",
          query: {
            itmkndCd: this.$store.state.Telemeter.selectedTmParam.itmkndCd,
            ofcCd: this.$store.state.Telemeter.selectedTmParam.ofcCd,
            obsCd: this.$store.state.Telemeter.selectedTmParam.obsCd,
            appTime: Util.formatDate(
              this.$store.state.app.appTime,
              "YYYY-MM-DD HH:mm"
            ),
            isCurrent: this.$store.state.app.isCurrent,
            fld: this.$store.state.app.fldCtlParty,
          },
        });
        window.open(routeData.href, "_blank", "noreferrer,noopener");
      } else {
        let routeData = this.$router.resolve({
          name: "tm",
          query: {
            itmkndCd: this.$store.state.Telemeter.selectedTmParam.itmkndCd,
            ofcCd: this.$store.state.Telemeter.selectedTmParam.ofcCd,
            obsCd: this.$store.state.Telemeter.selectedTmParam.obsCd,
            isCurrent: this.$store.state.app.isCurrent,
            fld: this.$store.state.app.fldCtlParty,
          },
        });
        window.open(routeData.href, "_blank", "noreferrer,noopener");
      }
    },
    /** お知らせボタン 文字 */
    setInfoText() {
      if (this.titleSummaryCode.pcText !== undefined) {
        return this.titleSummaryCode.pcText;
      } else {
        return this.text.info;
      }
    },
    /** お知らせボタン 着色 */
    setInfoColor() {
      if (this.infoConfig.titleSummaryCode !== undefined) {
        if (
          this.titleSummaryCode.backGroundColor !== undefined &&
          this.titleSummaryCode.textColor !== undefined
        ) {
          return {
            backgroundColor: this.titleSummaryCode.backGroundColor,
            color: this.titleSummaryCode.textColor
          };
        } else {
          // 設定ファイルにないsummaryCodeの場合、その他(summaryCode=5で着色)
          const code = 5;
          return {
            backgroundColor: this.infoConfig.titleSummaryCode[code].backGroundColor,
            color: this.infoConfig.titleSummaryCode[code].textColor
          }
        }
      } else {
        // 設定ファイルにtitleSummaryCodeが無い場合
        return {
          backgroundColor: "#ffffff",
          color: "#000000"
        }
      }
    },
    /** フレームの拡大縮小*/
    changePanelMode(bln) {
      this.$log.debug("[TmRain] changePanelMode(" + bln + ")");
      if (bln) {
        this.replacePanelMode("1");
        this.$store.commit("app/setPcPanelModeContent", "tmObs");
      } else {
        this.replacePanelMode("0");
        this.$store.commit("app/setPcPanelModeContent", null);
      }
      this.$store.commit("app/setPcPanelMode", bln);
    },
    showQwtrDbBtn(qwtrObsCd, dbLink) {
      if (qwtrObsCd !== null && qwtrObsCd !== undefined && dbLink === 1) {
        return true;
      } else {
        return false;
      }
    },
    openQwtrDb(qwtrObsCd) {
      let link =
        this.$store.state.app.config.appConfig.linkUrls.qwtrDbLink + qwtrObsCd;
      window.open(link);
    },
    openRnRank(qwtrObsCd) {
      let link =
        this.$store.state.app.config.appConfig.linkUrls.qwtrDbrnRkLink +
        qwtrObsCd;
      window.open(link);
    },
    linkInfoUrl(infoManageCd) {
      let infoDetailUrl = this.$router.resolve({
        path: "/pcfull/info/detail",
        query: {
          infmgcd: infoManageCd,
          fld: this.$store.state.app.fldCtlParty,
        },
      });
      window.open(infoDetailUrl.href, "_blank");
    },
  },
  /** 監視部 */
  watch: {
    information() {
      // お知らせが1件以上存在する場合、色とテキストを判定
      if (this.information.length > 0) {
        this.$store.dispatch("info/getInfoTitleColor", {
          information: this.information,
        });
      }

      // お知らせダイアログ非表示
      this.$store.commit("map/hideInfoRw");
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
